import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { image } from '../../../utils/data/baseUrl';
import classNames from 'classnames';
import { renderTextWithActions } from '../../../utils/renderTextWithActions';
import { useModal } from '../../../hooks/useModal';
import useStateControls from '../../../hooks/useStateControls';
import { useTranslation } from '../../../translations';

export default function FaqItem({ id, title, text, onClick, activeFaqs }) {
  const activeCondition = activeFaqs.includes(id);
  const { closeModal } = useModal();
  const { setState } = useStateControls();
  const { t } = useTranslation();

  const handleShopClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setState('gifts');
    closeModal({ type: 'all' });
  };

  return (
    <div className={classNames(`faq__item faq__item`)} onClick={onClick}>
      <div className={`faq__item-block`}>
        <div className={'faq__item-title'}>
          <div className={'faq__item-title-block'}>{safeHTML(t(title))}</div>
          <img
            className={classNames('faq__item-title-arrow', {
              'faq__item-title-arrow-reverse': activeCondition,
            })}
            src={image('faq/arrow.svg')}
            alt={'faq-arrow'}
          />
        </div>
        <div className={classNames('faq__item-text', { 'faq__item-text-active': activeCondition })}>
          <div className={'faq__item-text-block'}>{safeHTML(renderTextWithActions(t(text), handleShopClick))}</div>
        </div>
      </div>
    </div>
  );
}
